import React, { createContext, useContext, useEffect } from 'react';
import { useAuthContext } from './AuthContext';
import settingsService from '../services/settingsService';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageProvider({ children }) {
  const { currentUser: user } = useAuthContext();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Carica la lingua dalle impostazioni dell'utente quando l'utente è autenticato
    const loadUserLanguage = async () => {
      if (!user) return;

      try {
        const response = await settingsService.get();
        if (response.data?.language) {
          // Aggiorna la lingua solo se è diversa da quella corrente
          if (response.data.language !== i18n.language) {
            console.log('Caricamento lingua dalle impostazioni utente:', response.data.language);
            i18n.changeLanguage(response.data.language);
            localStorage.setItem('preferredLanguage', response.data.language);
          }
        }
      } catch (error) {
        console.error('Errore nel caricamento della lingua dalle impostazioni:', error);
      }
    };

    loadUserLanguage();
  }, [user, i18n]);

  // Funzione per cambiare la lingua
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem('preferredLanguage', language);
  };

  const value = {
    changeLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
} 